export const SET_HOLIDAY_LOADING = 'SET_HOLIDAY_LOADING'
export const SET_HOLIDAY = 'SET_HOLIDAY'
export const SET_OV_GET_LOCATIONS = 'SET_OV_GET_LOCATIONS'
export const ADD_USERS = 'ADD_USERS'
export const EDIT_USERS = 'EDIT_USERS'
export const DELETE_USERS = 'DELETE_USERS'